/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateExperimentRequest } from '../models/CreateExperimentRequest';
import type { EditExperimentRequest } from '../models/EditExperimentRequest';
import type { Experiment } from '../models/Experiment';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ExperimentService {

    /**
     * @param organizationId
     * @param requestBody
     * @returns Experiment OK
     * @throws ApiError
     */
    public static createExperiment(
        organizationId: string,
        requestBody?: CreateExperimentRequest,
    ): CancelablePromise<Experiment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/experiments/{organizationId}/create',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param organizationId
     * @param experimentId
     * @returns any OK
     * @throws ApiError
     */
    public static deleteExperiment(
        organizationId: string,
        experimentId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/experiments/{organizationId}/{experimentId}/delete',
            path: {
                'organizationId': organizationId,
                'experimentId': experimentId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * @param organizationId
     * @param requestBody
     * @returns Experiment OK
     * @throws ApiError
     */
    public static editExperiment(
        organizationId: string,
        requestBody?: EditExperimentRequest,
    ): CancelablePromise<Experiment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/experiments/{organizationId}/edit',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve an experiment.
     * @param organizationId The ID of the organization to scope the experiments for.
     * @param experimentId The ID of the experiment to retrieve.
     * @returns Experiment OK
     * @throws ApiError
     */
    public static getExperiment(
        organizationId: string,
        experimentId: string,
    ): CancelablePromise<Experiment> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/experiments/{organizationId}/{experimentId}',
            path: {
                'organizationId': organizationId,
                'experimentId': experimentId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve all experiments for the specified organization.
     * @param organizationId The ID of the organization to scope the experiments for.
     * @returns Experiment OK
     * @throws ApiError
     */
    public static getExperiments(
        organizationId: string,
    ): CancelablePromise<Array<Experiment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/experiments/{organizationId}',
            path: {
                'organizationId': organizationId,
            },
        });
    }

}
